module.exports = __webpack_public_path__ + "static/img/end03.2dcbfb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/end03.jpg
// module id = 1434
// module chunks = 0